import { selectCreferenceCanClick } from "./creferenceInteractionModel";
import { useCreferenceClickHandlers } from "./useCreferenceClickHandlers";
import { useCreferenceInternalActions } from "./useCreferenceInternalActions";
import { useCreferenceTransientState } from "./useCreferenceTransientState";
import type {
  CreferenceInteraction,
  UseCreferenceInteractionInput,
} from "./creferenceInteractionTypes";

export function useCreferenceInteraction({
  collab,
  disabled,
  effectiveEntityType,
  file,
  isCurrentUserReference,
  isLoading,
  isUnresolved,
  member,
  normalizedEntityId,
  onClick,
  product,
  version,
}: UseCreferenceInteractionInput): CreferenceInteraction {
  const transientState = useCreferenceTransientState();
  const internalActionByType = useCreferenceInternalActions({
    collab,
    file,
    isCurrentUserReference,
    member,
    normalizedEntityId,
    product,
    showMemberGlimpse: transientState.showMemberGlimpse,
    version,
  });
  const hasInternalClickAction = Boolean(internalActionByType[effectiveEntityType]);
  const canClick = selectCreferenceCanClick({
    disabled,
    hasInternalClickAction,
    isActionPending: transientState.isActionPending,
    isLoading,
    isUnresolved,
    onClick,
  });
  const { handleClick } = useCreferenceClickHandlers({
    canClick,
    effectiveEntityType,
    internalActionByType,
    normalizedEntityId,
    onClick,
    setIsActionPending: transientState.setIsActionPending,
    showAlreadyFocusedHint: transientState.showAlreadyFocusedHint,
  });

  return {
    canClick,
    dismissAlreadyFocusedHint: transientState.dismissAlreadyFocusedHint,
    handleClick,
    handleMemberGlimpseClose: transientState.handleMemberGlimpseClose,
    hintAnchorElement: transientState.hintAnchorElement,
    isAlreadyFocusedHintVisible: transientState.isAlreadyFocusedHintVisible,
    isHovered: transientState.isHovered,
    isMemberGlimpseVisible: transientState.isMemberGlimpseVisible,
    setHintAnchorElement: transientState.setHintAnchorElement,
    setIsHovered: transientState.setIsHovered,
  };
}
